export const relationship = {
  CH: 'Child',
  CUP: 'Civil Union/Domestic Partner',
  DP: 'Domestic Partner',
  SP: 'Spouse',
};
